import { ROOMS_EVENTS } from '../../constants/rooms';
import RoomsModel from '../Models/Rooms';
import { isMobile } from "../engine/helpers/worldHelpers";
import { createPopper } from '@popperjs/core';

export default class RoomsController {
    constructor() {
        this.model = new RoomsModel();

        // SORT ROOMS EVENTS
        this.sortRoomsEvents();

        // FILTER EVENTS
        this.filterEvents();

        // PAGINATION EVENTS
        this.paginationEvents();

        // ROOM INFO
        this.updateEvents();

        // GO TO TOP
        this.goTopEvents();

        document.addEventListener("click", () => {
            this.closeAllPopups();
        });

        this.initMobileModeProcessor()
        this.initFloatingCreateButton()
    }

    sortRoomsEvents = () => {
        // Initialize jQuery elements
        this.$sortBtn = $('#space-sort-btn');
        this.$sortPopup = $('#space-sort-popup');
        this.$sortInput = $('#space-sort-input')
        this.$sortOrderInput = $('#space-sort-order-input')
        this.sortPopper = null;

        if (this.$sortBtn.length && this.$sortPopup.length) {
            this.sortPopper = createPopper(this.$sortBtn[0], this.$sortPopup[0], {
                placement: 'bottom-end',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: document.body,
                        },
                    }
                ],
            });

            // Sort button click event
            this.$sortBtn.on('click', (e) => {
                e.stopPropagation();
                this.toggleSortPopup();
            });

            const reflectSortInput = () => {
                const $sortOptions = this.$sortPopup.find('.sort-option');
                $sortOptions.each((el, option) => {
                    $(option).removeClass('selected');

                    if ($(option).data('value') === this.$sortInput.val()) {
                        $(option).addClass('selected');
                    }
                })
            }
            const reflectSortOrderInput = () => {
                $('.space-popup__sort-direction').hide();
                $(`.space-popup__sort-direction[data-value="${this.$sortOrderInput.val()}"]`).show();
            }

            this.$sortInput.on('change', reflectSortInput)
            this.$sortOrderInput.on('change', reflectSortOrderInput)

            reflectSortInput()
            reflectSortOrderInput()

            // Sort options
            this.$sortPopup.find('.sort-option').on('click', (e) => {
                e.stopPropagation();
                const currentValue = $('#space-sort-input').val();

                const $option = $(e.currentTarget);
                const value = $option.data('value');

                if (value !== currentValue) {
                    $('#space-sort-input').val(value).trigger('change');
                    this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
                } else {
                    this.$sortPopup.find('.space-popup__sort-direction:visible').click()
                }
            });

            // Order options
            this.$sortPopup.find('.space-popup__sort-direction').on('click', (e) => {
                e.stopPropagation();
                const $option = $(e.currentTarget);
                const value = $option.data('valueOnclick');

                if (value) {
                    $('#space-sort-order-input').val(value).trigger('change');
                    this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
                }
            });
        }

        // A-Z / Z-A
        $("#order-rooms-select-label").on("click", () => {
            $("#order-rooms").trigger("click");
        });

        $("#order-rooms").on("change", () => {
            this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
        });
    }

    filterEvents = () => {
        // Initialize jQuery elements
        this.$filterBtn = $('#space-filter-btn');
        this.$filterPopup = $('#space-filter-popup');
        this.filterPopper = null;

        // Initialize popper instances if elements exist
        if (this.$filterBtn.length && this.$filterPopup.length) {
            this.filterPopper = createPopper(this.$filterBtn[0], this.$filterPopup[0], {
                placement: 'bottom-end',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [56, 8],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: document.body,
                        },
                    }
                ],
            });

            // Filter button click event
            this.$filterBtn.on('click', (e) => {
                e.stopPropagation();
                this.toggleFilterPopup();
            });

            // Clear filter button
            this.$filterPopup.find('#space-clear-filter-btn').on('click', (e) => {
                e.stopPropagation();
                this.clearFilters();
            });

            // Language select
            $('#space-language-filter').on('change', (e) => {
                this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
            });

            // Has Chess Game checkbox
            const reflectChessOption = () => {
                const isChecked = $('#space-has-chess-filter').is(':checked');
                $('#space-has-chess-option').toggleClass('selected', !!isChecked);
            }
            $('#space-has-chess-filter').on('change', (e) => {
                reflectChessOption();
                this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
            });
            // Click anywhere on the option to toggle
            $('#space-has-chess-option').on('click', (e) => {
                // avoid double triggers when the hidden input would be clicked programmatically
                if (e.target && (e.target.id === 'space-has-chess-filter')) return;
                const $cb = $('#space-has-chess-filter');
                $cb.prop('checked', !$cb.is(':checked')).trigger('change');
            });
            // initial reflect
            reflectChessOption();
        }

        // Prevent default submit
        $('.spaces-header__search').on('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
        })

        // Search button
        $('#search-search-btn').on('click', () => {
            this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
        })

        // TODO: keep old code for now
        // OPEN FILTERS CONTAINER
        $("#open-rooms-filters, #open-rooms-filters-label").on("click", () => {
            $("#filters-container").addClass("active");
        });

        // CLOSE FILTERS CONTAINER
        $("#close-rooms-filters").on("click", () => {
            $("#filters-container").removeClass("active");
        });

        // APPLY FILTERS
        $("#apply-room-filters").on("click", () => {
            $("#filters-container").removeClass("active");
        });

        // SEARCH ROOM
        let searchRoomDebounce = null;
        $("#search-room").on("keyup", (e) => {
            clearTimeout(searchRoomDebounce);
            const search = $(e.currentTarget).val();

            this.model.updateURL('search', search);

            searchRoomDebounce = setTimeout(() => {
                this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
            }, 200);
        });

        $("#search-room").on("focus", (e) => {
            $('.spaces-header').addClass('spaces-header--focused');
        });

        $("#search-room").on("blur", (e) => {
            $('.spaces-header').removeClass('spaces-header--focused');
        });

        let scrollDebounce = null;
        let $body = $('body');
        $body.on("scroll", () => {
            clearTimeout(scrollDebounce);

            scrollDebounce = setTimeout(() => {
                const currentScrollTop = $body.scrollTop();
                const $spaceHeader = $(".spaces-header");
                const $navbar = $("#main_navbar");

                if (currentScrollTop > $navbar.outerHeight()) {
                    // Scroll down
                    $spaceHeader.addClass('spaces-header--collapsed');
                } else {
                    // Scroll up
                    $spaceHeader.removeClass('spaces-header--collapsed');
                }
            }, 100);
        });
    }

    paginationEvents = () => {
        $(document).on('click', '.rooms-container__load-more', (e) => {
            e.preventDefault();
            this.model.dispatchEvent({
              type: ROOMS_EVENTS.ROOMS_PAGING_CHANGED,
              data: {
                page: Number($(e.currentTarget).attr('data-page') || 1)
              }
            });
        })
    }

    updateEvents = () => {
        $(document).on("click", ".delete-room", (e) => {
            this.model.confirm(`Are you sure you want to delete <b>${$(e.currentTarget).attr('data-name')}</b> room?`, () => {
                $.post($(e.target).parent().attr("data-href"), function (data) {
                    console.log(data)
                });
            }, { header: true, title: 'Delete room?', confirmBtnTxt: 'Delete', logo: false });
        });
    }

    goTopEvents = () => {
        $("#go-top").on("click", () => {
            $("html, body").animate({ scrollTop: $("#main_navbar").offset().top }, 300);
        });

        $("body").on("scroll", function () {
            const y = $(this).scrollTop();
            $("#go-top").toggleClass("visible", y > 200);
        });
    }

    initMobileModeProcessor = () => {
        const processMobileMode = () => {
            const isMobileMode = isMobile();
            $('body').toggleClass('is-mobile-mode', isMobileMode)
            $('body').toggleClass('is-desktop-mode', !isMobileMode)
            if (isMobileMode && window.matchMedia("(orientation: portrait)").matches) {
                $('body').addClass('is-portrait-mode');
            } else {
                $('body').removeClass('is-portrait-mode');
            }
        }

        let windowResizeDebounce;
        // Listen for window resize events and debounce the execution to prevent excessive updates
        window.addEventListener('resize', () => {
            clearTimeout(windowResizeDebounce);
            windowResizeDebounce = setTimeout(() => {
                processMobileMode()
            }, 200);
        });

        window.addEventListener("pageshow", () => {
            processMobileMode()
        })

        // Initial check to set 'is-mobile-mode' class on page load
        processMobileMode()
    }

    initFloatingCreateButton = () => {
        const $createRoomButton = $('#create-space');
        const $footer = $('#main_footer');
        const $body = $('body');

        // The spaces presence bar already lines this button up with messages and people.
        if ($createRoomButton.closest('.spaces-presence').length) {
            return;
        }

        if ($createRoomButton.length && $footer.length) {
            const updateButtonPosition = () => {
                const scrollTop = $body.scrollTop();
                const windowHeight = $(window).height();
                const documentHeight = $(document).height();
                const footerHeight = $footer.outerHeight();
                const buttonHeight = $createRoomButton.outerHeight();

                // Check if we're near the footer
                const scrollBottom = documentHeight - (scrollTop + windowHeight);

                if (scrollBottom <= footerHeight) {
                    // We're at or near the footer, position the button above it
                    let margin = 24; // Default desktop margin

                    if (isMobile()) {
                        if (window.matchMedia("(orientation: portrait)").matches) {
                            margin = 8; // Mobile margin
                        } else {
                            margin = 16; // Tablet margin
                        }
                    }

                    $createRoomButton.css({
                        'position': 'fixed',
                        'bottom': (footerHeight + margin) + 'px'
                    });
                } else {
                    // Normal scrolling, keep it fixed
                    $createRoomButton.css({
                        'position': '',
                        'bottom': ''
                    });
                }
            };

            // Update on scroll
            $body.on('scroll', updateButtonPosition);

            // Update on window resize
            $(window).on('resize', updateButtonPosition);

            // Initial position
            updateButtonPosition();
        }
    }

    toggleFilterPopup() {
        // Close sort popup if open
        this.closeSortPopup();

        // Toggle filter popup
        const isActive = this.$filterPopup?.hasClass('active');
        this.$filterPopup?.toggleClass('active');

        // Update popper position
        if (!isActive && this.filterPopper) {
            this.filterPopper.update();
        }
    }

    toggleSortPopup() {
        // Close filter popup if open
        this.closeFilterPopup();

        // Toggle sort popup
        const isActive = this.$sortPopup?.hasClass('active');
        this.$sortPopup?.toggleClass('active');

        // Update popper position
        if (!isActive && this.sortPopper) {
            this.sortPopper.update();
        }
    }

    closeFilterPopup() {
        this.$filterPopup?.removeClass('active');
    }

    closeSortPopup() {
        this.$sortPopup.removeClass('active');
    }

    closeAllPopups() {
        this.closeFilterPopup();
        this.closeSortPopup();
    }

    clearFilters() {
        $('#space-language-filter').val('');
        $('#space-has-chess-filter').prop('checked', false).trigger('change');

        this.model.dispatchEvent({ type: ROOMS_EVENTS.ROOMS_FILTER_CHANGED });
    }
}
